<template>
    <div style="min-height: 101vh; ">
        <div class="logo-container">
            <div class="logo-wrapper">
                <img src="../assets/home28.png" alt="" class="logo">
            </div>
            <div class="nav-links">
                <router-link to="/" class="nav-item">首页</router-link>
                <router-link to="/product" class="nav-item nav-item3">雾曼技术和产品</router-link>
                <router-link to="/Dynamic" class="nav-item">雾曼动态</router-link>
                <router-link to="/about" class="nav-item">关于雾曼</router-link>
                <router-link to="/contact" class="nav-item">联系雾曼</router-link>
                <router-link to="/Cooperation" class="nav-item">成为合伙人</router-link>
            </div>
            <div class="consult-button" @click="navigateToConsult">需求咨询</div>

            <!-- 改回使用实际的DOM元素作为汉堡按钮 -->
            <div class="mobile-menu-btn" @click="showMobileMenu = !showMobileMenu">
                <span></span>
                <span></span>
                <span></span>
            </div>

            <!-- 移动端菜单 -->
            <div class="mobile-menu" :class="{ 'show': showMobileMenu }">
                <div class="mobile-menu-item" @click="$router.push('/')">首页</div>
                <div class="mobile-menu-item" @click="$router.push('/Dynamic')">雾曼动态</div>
                <div class="mobile-menu-item" @click="$router.push('/about')">关于雾曼</div>
                <div class="mobile-menu-item" @click="$router.push('/contact')">联系雾曼</div>
                <div class="mobile-menu-item" @click="$router.push('/Cooperation')">成为合伙人</div>
                <div class="mobile-menu-item highlight" @click="navigateToConsult">需求咨询</div>
            </div>
        </div>

        <div>
            <div class="product-container">
                <div class="product-content">
                    <div class="product-title">
                        <div class="title-text">{{ productDetail.title }}</div>
                        <div class="product-tag" v-if="productDetail.keywords && productDetail.keywords.length">
                            {{ productDetail.keywords[0] }}
                        </div>
                    </div>
                    <div class="product-features">
                        <div v-for="(feature, index) in summaryList" :key="index">
                            {{ feature }}
                        </div>
                    </div>
                    <div class="feature-cards">
                        <div class="feature-card" v-for="(tag, index) in productDetail.tags" :key="index">
                            <div class="card-title" v-if="getTagPrefix(tag)">{{ getTagPrefix(tag) }}</div>
                            <div class="card-value">{{ getTagNumber(tag) }}</div>
                            <div class="card-desc" v-if="getTagSuffix(tag)">{{ getTagSuffix(tag) }}</div>
                        </div>
                    </div>
                    <div class="action-buttons" @click="navigateToConsult">
                        <div class="action-btn">
                            <div class="btn-icon">
                                <img src="../assets/contact/contact3.png" alt="">
                            </div>
                            <div class="btn-text">咨询详情</div>
                        </div>
                    </div>
                </div>
                <div style="width: 365px;margin-top:120px;">
                    <img style="width: 100%; height: auto; object-fit: contain;" :src="productDetail.logoSrc" alt="">
                </div>
            </div>
            <div style="min-height: 100px; ">
                <div class="content-html" v-html="productDetail.contentHtml"></div>
            </div>

        </div>
        <!--<div class="Aichat">
            <ChatWidget :defaultOpen="isOpen" />
            <div class="Aitext" @click="openChat">AI小曼</div>
        </div>-->
    </div>
</template>
for file in *.{jpg,png}; do
  cwebp -q 50 "$file" -o "${file}.webp"
done
<script>
export default {
    name: 'Product',
    data() {
        return {
            productDetail: true,
            summaryList: [],
            showMobileMenu: false
        }
    },
    async created() {
        try {
            const id = this.$route.query.id || "636511271170117"
            if (!id) {
                console.error('缺少产品ID')
                return
            }

            console.log('开始请求产品详情数据, id:', id)
            const response = await this.$http.get('cms/content/detail/636455896526917/article/' + id)

            console.log('API响应:', response)

            if (response.data && response.code === 200) {
                this.productDetail = response.data
                console.log('设置产品详情数据:', this.productDetail)

                // 处理summary字段，按换行符分割
                if (this.productDetail.summary) {
                    this.summaryList = this.productDetail.summary.split('\n')
                    console.log('处理后的summaryList:', this.summaryList)
                }
            } else {
                console.error('API响应错误:', response.data)
            }
        } catch (error) {
            console.error('获取产品详情失败:', error)
        }
    },
    methods: {
        getTagPrefix(tag) {
            // 获取数字前的文字
            const match = tag.match(/(.*?)\d+/);
            return match ? match[1] : '';
        },
        getTagNumber(tag) {
            // 获取数字和单位
            const match = tag.match(/\d+.*?(?=[^\d/％%]|$)/);
            return match ? match[0] : tag;
        },
        getTagSuffix(tag) {
            // 获取数字和单位后的文字
            const match = tag.match(/\d+.*?(?=[^\d/％%]|$)(.*)/);
            return match ? match[1] : '';
        },
        navigateToConsult() {
            this.$router.push('/contact').then(() => {
                setTimeout(() => {
                    window.scrollTo({
                        top: 1000,
                        behavior: 'smooth'
                    });
                }, 500);
            });
        },
        openChat() {
            console.log(this.isOpen)
            this.isOpen = !this.isOpen
        }
    }
}
</script>

<style scoped>
.mobile-menu {
    display: none;
}

.header {
    display: flex;
    height: 65px;
    background: #FFFFFF;
    box-shadow: inset 0px -1px 0px 0px rgba(0, 0, 0, 0.06);
}

.logo-container {
    width: 236px;
    height: 32px;
    padding-left: 34px;
    padding-top: 17px;
    background: #fff;
}

.nav-menu {
    display: flex;
    line-height: 65px;
    font-size: 14px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    margin: auto;
}

.nav-item {
    padding: 0 19px;
    font-size: 15px;
}

.consult-btn {
    font-size: 13px;
    color: #FFFFFF;
    width: 89px;
    height: 30px;
    background: #B80708;
    border-radius: 16px;
    text-align: center;
    line-height: 30px;
    margin: 10px 50px 0 0;
}

.product-container {
    width: 1334px;
    background: #fff;
    padding: 53px 0 84px 0;
    margin: auto;
    display: flex;
}

.product-content {
    width: 1336px;
    margin: auto;
    padding-top: 20px;
}

.product-title {
    display: flex;
    align-items: center;
    padding-top: 30px;
}

.title-text {
    font-size: 52px;
    font-weight: 600;
    color: #041214;
    line-height: 1;
}

.product-tag {
    width: 159px;
    height: 28px;
    background: #F1FAEC;
    border-radius: 4px;
    font-size: 16px;
    color: #24A80A;
    line-height: 28px;
    text-align: center;
    font-style: normal;
    font-weight: bold;
    margin-left: 10px;
}

.product-features {
    font-size: 14px;
    font-weight: 400;
    color: #6D7278;
    margin-top: 20px;
}

.feature-cards {
    display: flex;
    padding-top: 39px;
}

.feature-card {
    margin-right: 11px;
    width: 222px;
    height: 120px;
    background: #F5F6F7;
    border-radius: 7px;
    padding: 19px 0 19px 22px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.feature-card:last-child {
    margin-right: 0;
}

.card-title {
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    font-weight: 600;
    min-height: 24px;
}

.card-value {
    color: #B80708;
    font-size: 30px;
    font-weight: bold;
    min-height: 36px;
}

.card-desc {
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    font-weight: 400;
    min-height: 20px;
}

.action-buttons {
    display: flex;
    padding-top: 48px;
    cursor: pointer;
}

.action-btn {
    margin-right: 24px;
    display: flex;
    width: 292px;
    height: 52px;
    background: #B80708;
    border-radius: 7px;
    padding: 13px 0 0 100px;
}

.btn-icon {
    width: 25px;
    height: 25px;
}

.btn-text {
    color: #FFFFFF;
    font-size: 16px;
    font-weight: 600;
    padding-left: 5px;
}

.product-image {
    width: 365px;
    height: 497px;
}

.image-container {
    width: 365px;
    height: 497px;
}

.product-content-html {
    margin-top: 20px;
    padding: 20px;
}

.loading {
    text-align: center;
    padding: 50px;
    font-size: 16px;
    color: #666;
}

.content-html {
    margin: 20px;
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin: auto;
}

.content-html :deep(p) {
    font-size: 16px;
    line-height: 1.6;
    margin: 12px 0;
    color: #666;
}

.nav-item2 {
    border-bottom: 2px solid #FFFFFF;
}

.nav-item3 {
    border-bottom: 2px solid #FF0000;
    color: #FF0000;
}

/* 移动端适配样式 */
@media screen and (max-width: 768px) {
    .header {
        height: 50px;
        padding: 0 15px;
        position: relative;
    }

    .logo-container {
        padding: 15px 0;
        width: auto;
    }

    .logo-container img {
        height: 20px;
        width: auto;
    }

    .nav-menu {
        display: none;
    }

    .nav-menu-mobile {
        display: flex;
        flex-direction: column;
        position: fixed;
        top: 50px;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.9);
        padding: 20px 0;
        z-index: 100;
    }

    .nav-menu-mobile .nav-item {
        color: rgba(0, 0, 0, 0.85);
        padding: 15px 20px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        text-align: center;
    }

    .menu-toggle {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 25px;
        height: 20px;
        position: absolute;
        right: 15px;
        top: 15px;
    }

    .menu-toggle span {
        width: 100%;
        height: 2px;
        background-color: #000;
    }

    .consult-btn {
        display: none;
    }

    .consult-button-mobile {
        background: #B80708;
        color: white;
        margin: 10px 20px;
        border-radius: 16px;
    }

    .product-container {
        width: 100%;
        padding: 20px;
        flex-direction: column;
    }

    .product-content {
        width: 100%;
    }

    .title-text {
        font-size: 32px;
    }

    .feature-cards {
        flex-direction: column;
    }

    .feature-card {
        width: 100%;
        margin-right: 0;
        margin-bottom: 10px;
    }

    .action-buttons {
        padding-top: 30px;
        cursor: pointer;
    }

    .action-btn {
        width: 100%;
        margin-right: 0;
        justify-content: center;
        padding: 13px 0;
    }

    .content-html {
        margin: 10px;
        padding: 15px;
    }

    /* 移动端才显示的元素 */
    .logo-container:after {
        content: '';
        display: block;
    }

    .logo-container {
        position: relative;
    }

    /* 添加移动端菜单按钮 */
    .logo-container:before {
        content: '';
        position: absolute;
        right: 15px;
        width: 30px;
        height: 25px;
        cursor: pointer;
        background-image: linear-gradient(to bottom,
                #000 20%,
                transparent 20% 40%,
                #000 40% 60%,
                transparent 60% 80%,
                #000 80%);
    }

    /* 移动端菜单 */
    .mobile-menu {
        display: none;
        position: fixed;
        top: 50px;
        left: 0;
        width: 100%;
        background: rgba(0, 0, 0, 0.9);
        padding: 20px 0;
        z-index: 999;
    }

    .mobile-menu.show {
        display: block;
    }

    .mobile-menu-item {
        color: #fff;
        padding: 15px 20px;
        font-size: 16px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }

    .mobile-menu-item.highlight {
        color: #0A2E43;
        background: #fff;
        margin: 10px 15px;
        border-radius: 17px;
        text-align: center;
    }

    /* 处理图片容器 */
    .product-container>div[style*="width: 365px"] {
        width: 100% !important;
        padding: 0 15px;
    }

    .product-container img {
        max-width: 100%;
        height: auto;
        object-fit: contain;
    }
}
</style>
<style scoped>
.home-container {
    width: 100%;
    height: 380px;
    background-color: #000;
    background-image: url("../assets/coop/coop1.png");
    background-size: cover;
    background-position: center;
}

.logo-container {
    width: 100%;
    height: 70px;
    /* background: rgba(0, 0, 0, 0.2); */
    backdrop-filter: blur(3px);
    padding: 0 55px;
    display: flex;
    align-items: center;
    position: relative;
}

.logo-wrapper {
    position: absolute;
}

.logo {
    width: 251px;
    height: 32px;
}

.nav-links {
    display: flex;
    color: rgba(0, 0, 0, 0.85);
    font-size: 15px;
    font-weight: 600;
    font-style: normal;
    text-align: center;
    margin: auto;
    height: 68px;
    line-height: 70px;
    cursor: pointer;
}

.nav-item {
    padding: 0 20px;
}

.nav-item2 {
    border-bottom: 2px solid #FFFFFF;
}

.consult-button {
    background: #B80708;
    border-radius: 17px;
    width: 96px;
    height: 32px;
    font-weight: 600;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 32px;
    text-align: center;
    position: absolute;
    right: 54px;
}

/* 移动端菜单按钮样式 */
.mobile-menu-btn {
    display: none;
}

@media screen and (max-width: 768px) {
    .mobile-menu-btn {
        display: block;
        position: absolute;
        right: 15px;
        width: 30px;
        height: 25px;
        cursor: pointer;
        z-index: 1000;
    }

    .mobile-menu-btn span {
        display: block;
        width: 100%;
        /* height: 2px; */
        background-color: #000;
        margin: 6px 0;
        transition: 0.3s;
    }

    .mobile-menu {
        display: none;
        position: fixed;
        top: 50px;
        left: 0;
        width: 100%;
        background: rgba(0, 0, 0, 0.9);
        padding: 20px 0;
        z-index: 999;
    }

    .mobile-menu.show {
        display: block;
    }

    .mobile-menu-item {
        color: #fff;
        padding: 15px 20px;
        font-size: 16px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }

    .mobile-menu-item.highlight {
        color: #0A2E43;
        background: #fff;
        margin: 10px 15px;
        border-radius: 17px;
        text-align: center;
    }

    /* 导航栏移动端适配 */
    .logo-container {
        height: 50px;
        padding: 0 15px;
    }

    .logo {
        width: 150px;
        height: 20px;
    }

    .nav-links {
        display: none;
    }

    .consult-button {
        display: none;
    }

    /* 产品内容区域移动端适配 */
    .product-container {
        width: 100%;
        padding: 20px;
        flex-direction: column;
    }

    .product-content {
        width: 100%;
    }

    .title-text {
        font-size: 28px;
    }

    .feature-cards {
        flex-direction: column;
        gap: 10px;
    }

    .feature-card {
        width: 100%;
        margin-right: 0;
    }

    .action-btn {
        width: 100%;
        margin-right: 0;
        justify-content: center;
        padding: 13px 0;
    }

    .content-html {
        margin: 10px;
        padding: 15px;
    }
}

/* 当菜单打开时的汉堡按钮动画 */
.mobile-menu-btn.active span:nth-child(1) {
    transform: rotate(45deg) translate(5px, 5px);
}

.mobile-menu-btn.active span:nth-child(2) {
    opacity: 0;
}

.mobile-menu-btn.active span:nth-child(3) {
    transform: rotate(-45deg) translate(7px, -7px);
}
</style>